import { faMessages } from '@fortawesome/pro-light-svg-icons/faMessages'
import type { CommunityGroupCreateResponse } from '@space-lib-events/toggleCommunityGroupModal'
import Icon from '@space-lib/components/icon'

import styled from 'styled-components'

import CollapseHeaderActions from './collapseHeaderActionsOld'
import { CollapseTitle } from './collapseTitle'

const CustomIcon = styled(Icon)`
  width: 1.25rem;
  height: 1.25rem;
`

export type CollapseHeaderProps = {
  group: CommunityGroupCreateResponse
  hasActions: boolean
  handleAddCommunity: () => void
  isOpen?: boolean
}

const CollapseHeader = ({ group, hasActions, handleAddCommunity, isOpen }: CollapseHeaderProps) => {
  if (!isOpen) {
    return (
      <div className='_d-flex _align-items-center _justify-content-center _h-5 _w-5'>
        <CustomIcon icon={faMessages} className='_text-gray-500' />
      </div>
    )
  }

  if (hasActions) {
    return (
      <CollapseHeaderActions
        version='old'
        group={group}
        toggleAddCommunityModal={handleAddCommunity}
      />
    )
  }

  return <CollapseTitle version='old'>{group.name}</CollapseTitle>
}

export default CollapseHeader
